import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state.socialMarketTransactions,
    (state) => state
)

export const selectTransactions = createSelector(
    baseSelector,
    (state) => state.transactions
)

export const selectTransactionsDeals = createSelector(
    baseSelector,
    (state) => state.deals
)

export const selectTransactionsError = createSelector(
    baseSelector,
    (state) => state.transactionsError
)

export const selectTransactionsLoading = createSelector(
    baseSelector,
    (state) => state.isTransactionsLoading
)

export const selectTransactionsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isTransactionsFirstLoad
)

export const selectTransactionsEnd = createSelector(
    baseSelector,
    (state) => state.end
)

export const selectStartDate = createSelector(
    baseSelector,
    (state) => state.startDate
)

export const selectEndDate = createSelector(
    baseSelector,
    (state) => state.endDate
)

export const selectDestType = createSelector(
    baseSelector,
    (state) => state.destType
)

export const selectSelectedPartner = createSelector(
    baseSelector,
    (state) => state.selectedPartner
)

export const selectSocialMarketPartners = createSelector(
    baseSelector,
    (state) => state.partners
)

export const selectSocialMarketPartnersFirstLoad = createSelector(
    baseSelector,
    (state) => state.isPartnersFirstLoad
)

export const selectSocialMarketPartnersLoading = createSelector(
    baseSelector,
    (state) => state.isPartnersLoading
)